(function () {
  const BNPL_SELECTOR = '[data-allure-bnpl]';

  function formatMoneyFromCents(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function parsePaymentTermsMeta(element) {
    const raw = element?.getAttribute('shopify-meta');
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function getVariantTerm(meta, variantId) {
    if (!meta?.variants?.length) return null;
    const match = meta.variants.find((v) => String(v.id) === String(variantId));
    if (!match?.eligible || !match?.available) return null;
    return match.price_per_term || null;
  }

  function updateDisplay(wrapper, variantId, variantPriceCents) {
    const amountEl = wrapper.querySelector('[data-bnpl-amount]');
    const count = parseInt(wrapper.dataset.installmentCount, 10) || 4;
    const terms = wrapper.querySelector('shopify-payment-terms');
    const meta = parsePaymentTermsMeta(terms);
    const termFromShopify = getVariantTerm(meta, variantId);

    if (amountEl) {
      if (termFromShopify) {
        amountEl.textContent = termFromShopify;
      } else if (variantPriceCents) {
        amountEl.textContent = formatMoneyFromCents(Math.round(variantPriceCents / count));
      }
    }
  }

  function openPaymentOptions(wrapper) {
    const terms = wrapper.querySelector('shopify-payment-terms');
    if (!terms) return;

    const shadowLink = terms.shadowRoot?.querySelector('a[href], button, [role="button"]');
    if (shadowLink) {
      shadowLink.click();
      return;
    }

    terms.click();
  }

  function syncVariantInput(wrapper, variantId) {
    const input = wrapper.querySelector('[data-bnpl-variant-input]');
    if (input && variantId) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function observePaymentTerms(wrapper) {
    const terms = wrapper.querySelector('shopify-payment-terms');
    if (!terms || terms.dataset.bnplObserved) return;
    terms.dataset.bnplObserved = 'true';

    const refresh = () => {
      const variantId = wrapper.querySelector('[data-bnpl-variant-input]')?.value;
      updateDisplay(wrapper, variantId);
    };

    const observer = new MutationObserver(refresh);
    observer.observe(terms, { attributes: true, attributeFilter: ['shopify-meta', 'variant-id'] });
    refresh();
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.bnplInit) return;
    wrapper.dataset.bnplInit = 'true';

    const sectionId = wrapper.dataset.sectionId;
    observePaymentTerms(wrapper);

    wrapper.querySelector('[data-bnpl-options]')?.addEventListener('click', () => {
      openPaymentOptions(wrapper);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event?.data?.sectionId !== sectionId) return;
        const variant = event.data?.variant;
        if (!variant) return;
        syncVariantInput(wrapper, variant.id);
        setTimeout(() => updateDisplay(wrapper, variant.id, variant.price), 80);
      });
    }
  }

  function initAll() {
    document.querySelectorAll(BNPL_SELECTOR).forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
